module.exports = __webpack_public_path__ + "static/media/logo-white.a2d1de87.png";